import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl, formatAndThrowApiError } from '@/helpers/api';

export const useActivities = () => {
  const urlStr = `${getApiUrl()}/activity`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const response = await axios.get(url);
        return response.data;
      } catch (err) {
        formatAndThrowApiError(err);
      }
    },
    {
      dedupingInterval: 60000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const useActivitiesV2 = () => {
  const urlStr = `${getApiUrl()}/activity-v2`;
  const swr = useSWR(urlStr, async (url) => {
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  });
  return swr;
};

export const useActivity = (id) => {
  const urlStr = `${getApiUrl()}/activity/${id}`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const response = await axios.get(url);
        return response.data;
      } catch (err) {
        formatAndThrowApiError(err);
      }
    },
    {
      dedupingInterval: 60000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const usePostActivity = () => {
  const postActivity = async (payload) => {
    try {
      const url = `${getApiUrl()}/mega/activity`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return postActivity;
};

export const usePutActivity = () => {
  const putActivity = async (id, payload) => {
    try {
      const url = `${getApiUrl()}/mega/activity/${id}`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return putActivity;
};

export const useDeleteActivity = () => {
  const deleteActivity = async (id) => {
    try {
      const url = `${getApiUrl()}/mega/activity/${id}`;
      const response = await axios.delete(url);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return deleteActivity;
};

export const useReorderActivities = () => {
  const reorderActivities = async (payload) => {
    try {
      const url = `${getApiUrl()}/mega/activity/reorder`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return reorderActivities;
};

export const useActivityObject = (activityId) => {
  const activities = useActivitiesV2();
  const activity = activities.data.content[activityId];
  return activity;
};
